const LEGACY_CREDENTIAL_FAILURE_DETAILS = new Set([
  "invalid api key",
  "missing api key",
]);

const CREDENTIAL_FAILURE_CODES = new Set([
  "ACCOUNT_DEACTIVATED",
  "AUTH_REQUIRED",
  "INVALID_CREDENTIAL",
  "INVALID_TOKEN",
  "SESSION_EXPIRED",
]);

function getErrorDetail(payload) {
  if (typeof payload === "string") return payload;
  if (!payload || typeof payload !== "object") return "";
  return payload.detail || payload.error || "";
}

function getErrorCode(payload) {
  if (!payload || typeof payload !== "object") return "";
  const detail = payload.detail;
  if (detail && typeof detail === "object") return String(detail.code || "");
  return String(payload.code || "");
}

/**
 * The session is valid but has not accepted the current terms. It is a 403
 * with its own code, and deliberately NOT a credential failure: signing the
 * person out would throw away the pane when all they need is to accept.
 */
export function isTermsAcceptanceRequired(status, payload = null) {
  return (
    status === 403 && getErrorCode(payload).trim().toUpperCase() === "TERMS_ACCEPTANCE_REQUIRED"
  );
}

/**
 * A 401 always means credentials are missing or invalid. Older backend
 * versions returned 403 for an invalid API key, so accept only those exact
 * legacy details; ordinary 403 access-control failures must keep the key.
 */
export function isCredentialFailure(status, payload = null) {
  if (status === 401) return true;
  if (status !== 403) return false;

  if (CREDENTIAL_FAILURE_CODES.has(getErrorCode(payload).trim().toUpperCase())) {
    return true;
  }
  const detail = String(getErrorDetail(payload)).trim().toLowerCase();
  return LEGACY_CREDENTIAL_FAILURE_DETAILS.has(detail);
}
